const step_up = {
    verify_your_identity: 'Подтвердите свою личность',
    choose_method_description: 'Чтобы продолжить, подтвердите, что это вы, одним из следующих способов.',
    password: 'Пароль',
    password_description: 'Введите пароль от вашей учетной записи',
    enter_password_description: 'Введите пароль от вашей учетной записи, чтобы продолжить.',
    enter_verification_code_description: 'Введите код подтверждения, отправленный на {{identifier}}.',
    subject_proof_description: 'Чтобы продолжить, подтвердите, что это вы, через связанную с вашей учетную запись. После этого вы сможете настроить способ проверки.',
    subject_mismatch: 'Учетная запись не совпадает',
    subject_mismatch_description: 'Использованная учетная запись не привязана к вашей учетной записи. Используйте привязанную учетную запись и при необходимости переключите учетную запись у провайдера.',
    no_method_available: 'Нет доступного способа проверки',
    no_method_available_description: 'В вашей учетной записи нет способа, с помощью которого можно пройти эту проверку. Пожалуйста, обратитесь к администратору за помощью.',
};
export default Object.freeze(step_up);
